import { useLayout } from './core/layout.context';
import { Tab } from 'bootstrap';
import { DrawerComponent } from 'components/layout/initializers/drawer-component';
import { ScrollComponent } from 'components/layout/initializers/scroll-component';
import { ScrollTopComponent } from 'components/layout/initializers/scroll-top-component';
import { StickyComponent } from 'components/layout/initializers/sticky-component';
import { SwapperComponent } from 'components/layout/initializers/swapper-component';
import { ToggleComponent } from 'components/layout/initializers/toggle-component';
import { MenuComponent } from 'components/layout/menu';
import { useEffect, useRef } from 'react';

export function MasterInit() {
  const { config } = useLayout();
  const isFirstRun = useRef(true);
  const pluginsInitialization = () => {
    isFirstRun.current = false;
    setTimeout(() => {
      ToggleComponent.bootstrap();
      ScrollTopComponent.bootstrap();
      DrawerComponent.bootstrap();
      StickyComponent.bootstrap();
      MenuComponent.bootstrap();
      ScrollComponent.bootstrap();
      SwapperComponent.bootstrap();
      document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
        Tab.getOrCreateInstance(tab);
      });
    }, 500);
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      pluginsInitialization();
    }
  }, [config]);

  return <></>;
}
